import React from "react";
import { formatRangeVal, getExposure, bookClass, isSuspended, useRangeToggle } from "../../casinoComponents/userSiteLastResult/refUtils";
import { RangeIcon, RefRemark } from "../../casinoComponents/userSiteLastResult/refBits";
import { formatBook } from "../../../utils/formatOdds";
import Collapse from "../../../components/Collapse";

const BALL = (n) => `${import.meta.env.BASE_URL}assets/img/balls/cricket20/ball${n}.png`;

/**
 * Cricket Match 20-20 (cmatch20) bet area in the reference markup (inside .casino-detail):
 *   .teen20casino-container > .teen20left (Run 2-6) + .teen20right (Run 7-10), each
 *   .score-box > .team-score + .ball-icon + .blbox(.suspended) back/lay + .c20minmax (i) range
 *   + .casino-remark (non-empty remark). Markets = sub sorted by sr (subtype cmatch20).
 */
export default function Cmatch20Table({ raw = {}, exposures = {} }) {
  const [open, toggle] = useRangeToggle();
  const sub = Array.isArray(raw?.sub) ? raw.sub : [];
  const main = sub
    .filter((s) => !s?.subtype || s.subtype === "cmatch20")
    .sort((a, b) => Number(a?.sr) - Number(b?.sr));

  const box = (item, ball, id) => {
    const exp = getExposure(exposures, item?.nat);
    return (
      <div className="score-box" key={id}>
        <div className="team-score">
          <div /> <div />
        </div>{" "}
        <div className="ball-icon">
          <img src={BALL(ball)} alt="" />
        </div>{" "}
        <div className={`blbox${isSuspended(item) ? " suspended" : ""}`}>
          <div className="back">
            <span className="odds d-block">{item?.b}</span>
          </div>{" "}
          <div className="lay">
            <span className="odds d-block">{item?.l}</span>
          </div>
        </div>{" "}
        {/* Downline exposure (admin): only when there is a book for this run */}
        {exp !== 0 && (
          <div className="c20book">
            <span className={bookClass(exp)}>{formatBook(exp)}</span>
          </div>
        )}
        <div className="c20minmax">
          <RangeIcon id={id} open={!!open[id]} onToggle={toggle} iconClass="fas fa-info-circle float-right" />{" "}
          <Collapse id={id} open={!!open[id]} className="icon-range">
            {"\n                                                R:"}
            <span>{formatRangeVal(item?.min)}</span>-<span>{formatRangeVal(item?.max)}</span>
          </Collapse>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="teen20casino-container">
        <div className="teen20left">{[0, 1, 2, 3, 4].map((i) => box(main[i], i + 2, `minmax${i}`))}</div>{" "}
        <div className="teen20right">{[0, 1, 2, 3].map((i) => box(main[i + 5], i + 7, `minmaxr${i}`))}</div>
      </div>{" "}
      <RefRemark remark={raw?.remark} />
    </>
  );
}
